// @ts-ignore
import { createRequestActions } from 'store/actionCreators'

export const fetchGlobalValues = createRequestActions('ORG_LABELS/FETCH', () => ({
  request: {
    url: '/global-values',
  },
}))

export const createGlobalValue = createRequestActions('ORG_LABELS/CREATE', name => ({
  request: {
    url: '/global-values',
    method: 'POST',
    data: { name },
  },
  success: 'New Global Value successfully created',
}))

export const updateGlobalValue = createRequestActions('ORG_LABELS/UPDATE', ({ id, name }) => ({
  request: {
    url: `/global-values/${id}`,
    method: 'PUT',
    data: { name },
  },
  success: 'Global Value successfully updated',
}))

export const deleteGlobalValue = createRequestActions('ORG_LABELS/DELETE', labelId => ({
  request: {
    url: `/global-values/${labelId}`,
    method: 'DELETE',
  },
  labelId,
  success: 'Global Value successfully deleted',
}))
